// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._1yt4xh0m{padding:var(--_cw4itz)}\n._2rkofajl{border-radius:var(--ds-radius-small,3px)}._18m915vq{overflow-y:hidden}\n._1bsb1b7y{width:var(--_1xe2l1p)}\n._1e0c1ule{display:block}\n._1ltv1ghs{left:2.5%}\n._1reo15vq{overflow-x:hidden}\n._4t3i12iw{height:var(--_15ce6z9)}\n._4t3i1osq{height:100%}\n._bfhk1p0d{background-color:#44546f}\n._bfhkrcrw{background-color:hsla(0,0%,100%,.8)}\n._kqswstnw{position:absolute}\n._vchhusvi{box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
